import { useRef, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { apiError } from './shared';
import { geoAcknowledged, acknowledgeGeo } from './useGeolocationCapture';

export const useEmployeeClock = ({ period, setData, refresh, geo, controlledGeo }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [closingPreview, setClosingPreview] = useState(null);
  const [closingError, setClosingError] = useState('');
  const [prompts, setPrompts] = useState([]);
  const inFlight = useRef(false);
  const locate = async (entry, phase) => {
    if (controlledGeo?.prepare(entry, phase)) return;
    if (!await geo.prepare(entry, phase)) return;
    if (!geoAcknowledged()) { setPrompts(previous => [...previous, { entry, phase }]); return; }
    await geo.capture(entry, phase); refresh();
  };
  const clock = async (action, serviceDate) => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true); setError('');
    try {
      if (action === 'end') {
        const { data } = await axios.get(`${API}/internal-staff/me`, { withCredentials: true, timeout: 15000, params: { start_date: period.start, end_date: period.end } });
        setData(data);
        if (!data.closing_preview) { setError('Aucun pointage en cours.'); return; }
        setClosingError(''); setClosingPreview(data.closing_preview); return;
      }
      const { data } = await axios.post(`${API}/internal-staff/clock/start`, serviceDate ? { service_date: serviceDate } : {}, { withCredentials: true });
      setData(previous => ({ ...previous, open_entry: data, last_entry_today: data })); refresh();
      // La localisation ne prolonge pas le verrou d'action du pointage enregistré.
      void locate(data, 'start');
    } catch (err) { setError(apiError(err)); refresh(); }
    finally { inFlight.current = false; setBusy(false); }
  };
  const confirmEnd = async entryId => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true); setClosingError('');
    try {
      const { data } = await axios.post(`${API}/internal-staff/clock/end`, { entry_id: entryId, break_confirmed: true }, { withCredentials: true });
      setData(previous => ({ ...previous, open_entry: null, closing_preview: null, last_entry_today: data }));
      setClosingPreview(null); refresh(); void locate(data, 'end');
    } catch (err) { setClosingError(apiError(err)); refresh(); }
    finally { inFlight.current = false; setBusy(false); }
  };
  const answerNotice = async accepted => {
    const target = prompts[0];
    setPrompts(previous => previous.slice(1));
    if (!target) return;
    if (accepted) { acknowledgeGeo(); await geo.capture(target.entry, target.phase); }
    else await geo.declineNotice(target.entry, target.phase);
    refresh();
  };
  return { busy, error, clock, closingPreview, closingError, confirmEnd, cancelEnd: () => setClosingPreview(null),
    geoPrompt: prompts[0], acceptGeo: () => answerNotice(true), declineGeo: () => answerNotice(false) };
};